/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  CreateExportRequest,
  ExecutiveDashboard,
  ExportJob,
  ForbiddenResponse,
  GetExecutiveDashboardParams,
  NotFoundResponse,
  UnauthorizedResponse,
  UnprocessableEntityResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetExecutiveDashboardUrl = (params: GetExecutiveDashboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/dashboards/executive?${stringifiedParams}` : `/v1/dashboards/executive`
}

/**
 * Indicadores executivos do negocio num periodo: alunos, professores,
 * duplas, aulas, frequencia, receita, MRR, ticket medio, custo de
 * professores, margem estimada e inadimplencia.
 *
 * Exclusiva de Super Admin. As definicoes de MRR, ticket medio, custo de
 * professores, margem, frequencia e inadimplencia sao as fixadas no plano
 * da Onda 4 e estao registradas no roadmap para ratificacao.
 *
 * Este dashboard e agregado e nao lista pessoa; onde lista, e
 * `displayName`.
 * @summary Indicadores executivos do negocio
 */
export const getExecutiveDashboard = async (params: GetExecutiveDashboardParams, options?: Parameters<typeof apiFetch>[1]): Promise<ExecutiveDashboard> => {

  return apiFetch<ExecutiveDashboard>(getGetExecutiveDashboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExecutiveDashboardQueryKey = (params?: GetExecutiveDashboardParams,) => {
    return [
    `/v1/dashboards/executive`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExecutiveDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getExecutiveDashboard>>, TError = UnauthorizedResponse | ForbiddenResponse>(params: GetExecutiveDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveDashboard>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExecutiveDashboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExecutiveDashboard>>> = ({ signal }) => getExecutiveDashboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExecutiveDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExecutiveDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getExecutiveDashboard>>>
export type GetExecutiveDashboardQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetExecutiveDashboard<TData = Awaited<ReturnType<typeof getExecutiveDashboard>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetExecutiveDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutiveDashboard>>,
          TError,
          Awaited<ReturnType<typeof getExecutiveDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutiveDashboard<TData = Awaited<ReturnType<typeof getExecutiveDashboard>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetExecutiveDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutiveDashboard>>,
          TError,
          Awaited<ReturnType<typeof getExecutiveDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExecutiveDashboard<TData = Awaited<ReturnType<typeof getExecutiveDashboard>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetExecutiveDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveDashboard>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Indicadores executivos do negocio
 */

export function useGetExecutiveDashboard<TData = Awaited<ReturnType<typeof getExecutiveDashboard>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetExecutiveDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExecutiveDashboard>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExecutiveDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateExportUrl = () => {




  return `/v1/exports`
}

/**
 * Solicita uma exportacao assincrona e devolve 202 com o identificador do
 * trabalho.
 *
 * Super Admin exporta qualquer relatorio; professor exporta apenas o
 * proprio demonstrativo. **A exportacao e assincrona de proposito**: um PDF
 * de competencia inteira nao cabe no tempo de uma requisicao, e um `GET`
 * que bloqueia derruba o p95.
 *
 * O PDF respeita a mascara: o nome que aparece nele e o mesmo `displayName`
 * que aparece na API.
 * @summary Solicita uma exportacao assincrona
 */
export const createExport = async (createExportRequest: CreateExportRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ExportJob> => {

  return apiFetch<ExportJob>(getCreateExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createExportRequest)
  }
);}





export const getCreateExportMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExport>>, TError,{data: CreateExportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExport>>, TError,{data: CreateExportRequest}, TContext> => {

const mutationKey = ['createExport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExport>>, {data: CreateExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  createExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExportMutationResult = NonNullable<Awaited<ReturnType<typeof createExport>>>
    export type CreateExportMutationBody = CreateExportRequest
    export type CreateExportMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse

    /**
 * @summary Solicita uma exportacao assincrona
 */
export const useCreateExport = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExport>>, TError,{data: CreateExportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExport>>,
        TError,
        {data: CreateExportRequest},
        TContext
      > => {
      return useMutation(getCreateExportMutationOptions(options), queryClient);
    }
    export const getGetExportUrl = (exportId: string,) => {




  return `/v1/exports/${exportId}`
}

/**
 * Consulta o estado de uma exportacao.
 *
 * Somente quem criou a exportacao a alcanca. Quando pronta, a resposta traz
 * uma URL assinada de curta duracao. O artefato derivado e retido por 7
 * dias.
 * @summary Consulta o estado de uma exportacao
 */
export const getExport = async (exportId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ExportJob> => {

  return apiFetch<ExportJob>(getGetExportUrl(exportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExportQueryKey = (exportId: string,) => {
    return [
    `/v1/exports/${exportId}`
    ] as const;
    }


export const getGetExportQueryOptions = <TData = Awaited<ReturnType<typeof getExport>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportQueryKey(exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExport>>> = ({ signal }) => getExport(exportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: exportId !== null && exportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExportQueryResult = NonNullable<Awaited<ReturnType<typeof getExport>>>
export type GetExportQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExport>>,
          TError,
          Awaited<ReturnType<typeof getExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExport>>,
          TError,
          Awaited<ReturnType<typeof getExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consulta o estado de uma exportacao
 */

export function useGetExport<TData = Awaited<ReturnType<typeof getExport>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExportQueryOptions(exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






